import { BASE_URL } from './Constants';

export const GET_FREE_APPOINTMENTS = `${BASE_URL}api/external/Common/GetFreeTime`;
export const CREATE_PATIENT = `${BASE_URL}api/external/Common/CreatePatient`;
export const GET_BUSY_DAYS = `${BASE_URL}api/external/Common/GetBusyDays`;
export const CREATE_APPOINTMENT = `${BASE_URL}api/external/Common/CreateAppointment`;